import { Scale, Total } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { MonthName } from "../MonthName"
import { PictureCover } from "../PictureCover"

// The logo's share of the room between the month's name and its grid
const LOGO = 0.85

/** Roboto, a square calendar: all picture, the year low on its right; a
 * month's name centred at its head, the logo big in its middle, its grid under it. */
export const Roboto: CalendarDesign = {
  cover: PictureCover({ align: HorizontalAlign.RIGHT, at: 0, size: 0.08 }),
  page: ({ gap, labels, language, outer, short, year }, month) => {
    const [title, rest] = Slice.top(outer, Scale(short, 0.06), gap)
    const [grid, middle] = Slice.bottom(rest, Scale(outer.height, 0.32), gap)
    return [
      // the name in the secondary, and in the spot on the pantone's plate
      ...[PALETTE.secondary, PALETTE.spot].map(color =>
        Area.text(title, MonthName(month, language).toUpperCase(), color, HorizontalAlign.CENTER)
      ),
      // The logo, big, centred between the name and the grid, a little
      // short of filling it
      Area.logo(
        {
          height: Scale(middle.height, LOGO),
          width: Scale(middle.width, LOGO),
          x: Total(middle.x, Scale(middle.width, (1 - LOGO) / 2)),
          y: Total(middle.y, Scale(middle.height, (1 - LOGO) / 2)),
        },
        labels
      ),
      Area.grid(
        { ...grid, width: Scale(outer.width, 0.84), x: Total(outer.x, Scale(outer.width, 0.08)) },
        month,
        year
      ),
    ]
  },
  pages: "month",
}
